import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import PublicFooter from '../components/PublicFooter';
import MarkdownRenderer from '../components/MarkdownRenderer';
import usePageTitle from '../hooks/usePageTitle';
import { fetchLegalDocument, formatEffectiveDate } from '../utils/legal';

const TITLES = { terms: 'Terms of Use', privacy: 'Privacy Policy' };

// Public /terms and /privacy. Outside PrivateRoute/Layout on purpose, so a
// forecaster can read the text in a new tab while the update dialog is open.
export default function LegalPage({ document }) {
  const [searchParams] = useSearchParams();
  const version = searchParams.get('version');
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);
  const title = doc?.title || TITLES[document];
  usePageTitle(title);

  useEffect(() => {
    let cancelled = false;
    setDoc(null);
    setError(false);
    fetchLegalDocument(document, version)
      .then((data) => { if (!cancelled) setDoc(data); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [document, version]);

  return (
    <div className="min-h-screen bg-surface dark:bg-gray-870 text-slate-900 dark:text-gray-100 flex flex-col">
      <div className="print:hidden"><PublicNav/></div>

      <main className="flex-1 w-full">
        <article className="max-w-3xl mx-auto px-6 py-12 sm:py-16">
          <h1 className="text-3xl sm:text-4xl font-light -tracking-[0.02em] leading-[1.05] text-slate-900 dark:text-white">
            {title}
          </h1>
          {doc && (
            <p className="mt-3 text-sm text-slate-500 dark:text-gray-400">
              Effective {formatEffectiveDate(doc.version)}
            </p>
          )}
          {error && (
            <p role="alert" className="mt-8 text-sm text-red-600 dark:text-red-400">
              This document could not be loaded. Please try again later, or write to predico@inesctec.pt.
            </p>
          )}
          {!doc && !error && (
            <p className="mt-8 text-sm text-slate-500 dark:text-gray-400">Loading…</p>
          )}
          {doc && (
            <div className="mt-8">
              <MarkdownRenderer content={doc.content} />
            </div>
          )}
        </article>
      </main>

      <div className="print:hidden"><PublicFooter/></div>
    </div>
  );
}
